import axios from "axios";
import { getApiUrl } from "@/utils/api";

const API = getApiUrl();

/**
 * Poll a background AI job started by one of the `/admin/cms/...`,
 * `/admin/products/.../generate-job-description` or
 * `/property-articles/generate|regenerate` endpoints (all of which return
 * `{ job_id }` immediately instead of waiting on the LLM call).
 * Resolves with the job's `result` once `status` is "done", throws on
 * "error" or if it's still pending after `maxWaitMs`.
 */
export async function pollAiJob(jobId, { intervalMs = 2500, maxWaitMs = 180000 } = {}) {
  const start = Date.now();
  while (Date.now() - start < maxWaitMs) {
    const { data } = await axios.get(`${API}/admin/ai-jobs/${jobId}`, { withCredentials: true });
    if (data.status === "done") return data.result;
    if (data.status === "error") throw new Error(data.error || "AI generation failed");
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
  throw new Error("Still generating — check Admin > Log shortly, or try again.");
}
